export const roles = {
    admin: 'ROLE_ADMIN',
    client: 'ROLE_CLIENT',
    commercial: 'ROLE_COMMERCIAL'
};
export const rolesAll = [
    roles.admin,
    roles.client,
    roles.commercial
];

